"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getRoundedCanvas(sourceCanvas) {
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var width = sourceCanvas.width;
  var height = sourceCanvas.height;
  canvas.width = width;
  canvas.height = height;
  context.imageSmoothingEnabled = true;
  context.drawImage(sourceCanvas, 0, 0, width, height);
  context.globalCompositeOperation = 'destination-in';
  context.beginPath();
  context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
  context.fill();
  return canvas;
}

(function ($) {
  $('.triming-stage').each(function (i, el) {
    createCropper(i, el);
  }); //each
  //

  function createCropper(i, parent) {
    i++;
    var parentEl = '#triming-stage0' + i + ' ';
    var inputFilename = 'filename0' + i;
    var image = document.querySelector(parentEl + '.trimed_image');
    var button = document.querySelector(parentEl + '.crop_btn');
    var actions = document.querySelector(parentEl + '.actions');
    var filename = $("input[name='filename0" + i + "']").val();
    var croppable = false;
    var cropper = new Cropper(image, {
      aspectRatio: 64 / 56,
      autoCropArea: 1,
      viewMode: 1,
      ready: function ready() {
        //初回読み込み以外はファイルサイズチェック
        var str = image.src;

        if (str.indexOf('/themes/gekihen/common/images') == -1) {
          if (image.naturalWidth < 2000 || image.naturalHeight < 2000) {
            //alert('縦横2000px以上のファイルをご用意ください');
            swal("ご注意ください", "縦横2000px以上のファイルをご用意ください");
          }
        }

        filename = $("input[name='filename0" + i + "']").val(); //console.log('filename:',filename);

        if (i > 1 && !croppable && filename == '') {
          $('.mw_wp_form_input ' + parentEl).css('display', 'none');
        }

        croppable = true;
      }
    }); // Tooltip
    //$('[data-toggle="tooltip"]').tooltip();
    // Buttons

    if (!document.createElement('canvas').getContext) {
      $(parentEl + 'button[data-method="getCroppedCanvas"]').prop('disabled', true);
    }

    if (typeof document.createElement('cropper').style.transition === 'undefined') {
      $(parentEl + 'button[data-method="rotate"]').prop('disabled', true);
      $(parentEl + 'button[data-method="scale"]').prop('disabled', true);
    } // Methods


    actions
    /*.querySelector('.docs-buttons')*/
    .onclick = function (event) {
      var e = event || window.event;
      var target = e.target || e.srcElement;
      var cropped;
      var result;
      var input;
      var data;

      if (!cropper) {
        return;
      }

      while (target !== this) {
        if (target.getAttribute('data-method')) {
          break;
        }

        target = target.parentNode;
      }

      if (target === this || target.disabled || target.className.indexOf('disabled') > -1) {
        return;
      }

      data = {
        method: target.getAttribute('data-method'),
        target: target.getAttribute('data-target'),
        option: target.getAttribute('data-option') || undefined,
        secondOption: target.getAttribute('data-second-option') || undefined
      };
      cropped = cropper.cropped;

      if (data.method) {
        if (typeof data.target !== 'undefined') {
          input = document.querySelector(data.target);

          if (!target.hasAttribute('data-option') && data.target && input) {
            try {
              data.option = JSON.parse(input.value);
            } catch (e) {
              console.log(e.message);
            }
          }
        }

        switch (data.method) {
          case 'rotate':
            if (cropped && options.viewMode > 0) {
              cropper.clear();
            }

            break;

          case 'getCroppedCanvas':
            try {
              data.option = JSON.parse(data.option);
            } catch (e) {
              console.log(e.message);
            }

            if (uploadedImageType === 'image/jpeg') {
              if (!data.option) {
                data.option = {};
              }

              data.option.fillColor = '#fff';
            }

            break;
        }

        result = cropper[data.method](data.option, data.secondOption);

        switch (data.method) {
          case 'rotate':
            if (cropped && options.viewMode > 0) {
              cropper.crop();
            }

            break;

          case 'scaleX':
          case 'scaleY':
            target.setAttribute('data-option', -data.option);
            break;

          case 'getCroppedCanvas':
            if (result) {
              // Bootstrap's Modal
              $('#getCroppedCanvasModal').modal().find('.modal-body').html(result);

              if (!download.disabled) {
                download.download = uploadedImageName;
                download.href = result.toDataURL(uploadedImageType);
              }
            }

            break;

          case 'destroy':
            cropper = null;

            if (uploadedImageURL) {
              URL.revokeObjectURL(uploadedImageURL);
              uploadedImageURL = '';
              image.src = originalImageURL;
            }

            break;
        }

        if (_typeof(result) === 'object' && result !== cropper && input) {
          try {
            input.value = JSON.stringify(result);
          } catch (e) {
            console.log(e.message);
          }
        }
      }
    }; // fileReaderが完了した後にボタンクリックイベントを作成する必要があります。


    button.onclick = function () {
      var actionURL = '/wp-content/themes/gekihen/save-image.php';
      var is_cropper = $('body').hasClass('page-upload');
      var croppedCanvas;

      if (!croppable) {
        //alert('トリミングする画像が設定されていません。');
        swal("ご注意ください", "トリミングする画像が設定されていません。");
        return false;
      } // cropper.jsに用意されている機能です。


      croppedCanvas = cropper.getCroppedCanvas({
        width: 1200,
        height: 1200
      }); // 下記toBlob関数はブラウザによって名前が違います。

      var blob;

      if (croppedCanvas.toBlob) {
        croppedCanvas.toBlob(function (blob) {
          var trimedImageForm = new FormData();
          trimedImageForm.append('blob', blob); // この例ではAjaxにて送信します。

          $.ajax({
            url: actionURL,
            // POST送信先
            type: 'post',
            processData: false,
            contentType: false,
            data: trimedImageForm
          }).done(function (jsonResponse) {
            var responese = $.parseJSON(jsonResponse);

            if (responese.status == 'success') {
              //console.log(responese);
              if (is_cropper) {
                //window.location.href = '/uploadform/';
                //?imgfile=' + responese.msg + '&orderNum=' + responese.num + '&buyerEmail=' + responese.mail;//;
                //$("input[name='imgfile']").val(responese.msg);
                var action = '/uploadform/?imgfile=' + responese.msg;
                document.getElementById('formdata').setAttribute("action", action);
                document.getElementById('formdata').submit();
              } else {
                $("input[name='" + inputFilename + "']").val(responese.msg);
              } //alert('アップロードしました。');

            } else if (responese.status == 'error') {
              //alert('画像作成に失敗しました。再度お試しください。\n' + responese.msg);
              swal("画像作成に失敗しました", "再度お試しください。\n" + responese.msg, "error");
            } else {
              //alert('システムエラーが発生しました。');
              swal("システムエラーが発生しました", "再度お試しください。", "error");
            }
          }).fail(function (responese) {
            //alert('システムエラーが発生しました。');
            swal("システムエラーが発生しました", "再度お試しください。", "error"); // フレームワークによってはサーバーエラーをjsonで返してくれます。

            var responese = $.parseJSON(jsonResponse);
          });
        });
      } else if (croppedCanvas.msToBlob) {
        blob = croppedCanvas.msToBlob();
        var trimedImageForm = new FormData();
        trimedImageForm.append('blob', blob); // この例ではAjaxにて送信します。

        $.ajax({
          url: actionURL,
          // POST送信先
          type: 'post',
          processData: false,
          contentType: false,
          data: trimedImageForm
        }).done(function (jsonResponse) {
          var responese = $.parseJSON(jsonResponse);

          if (responese.status == 'success') {
            //console.log(responese);
            if (is_cropper) {
              var action = '/uploadform/?imgfile=' + responese.msg;
              document.getElementById('formdata').setAttribute("action", action);
              document.getElementById('formdata').submit();
            } else {
              $("input[name='" + inputFilename + "']").val(responese.msg);
            } //alert('アップロードしました。');

          } else if (responese.status == 'error') {
            //alert('画像作成に失敗しました。再度お試しください。\n' + responese.msg);
            swal("画像作成に失敗しました", "再度お試しください。\n" + responese.msg, "error");
          } else {
            //alert('システムエラーが発生しました。');
            swal("システムエラーが発生しました", "再度お試しください。", "error");
          }
        }).fail(function (responese) {
          //alert('システムエラーが発生しました。');
          swal("システムエラーが発生しました", "再度お試しください。", "error"); // フレームワークによってはサーバーエラーをjsonで返してくれます。

          var responese = $.parseJSON(jsonResponse);
        });
      } else {
        // これは少しわからないです。申し訳ない。
        imageURL = canvas.toDataURL();
      } // 画面にトリミング結果を出力する場合は下記が必要です。
      // 例ではAjaxにて送信済みでので、下記機能に特に意味がありません。（結果表示したところですでに送信済みですので。）


      var result = document.querySelector(parentEl + '.result');
      var roundedImage, roundedCanvas; //roundedCanvas = getRoundedCanvas(croppedCanvas);

      roundedCanvas = croppedCanvas;
      roundedImage = document.createElement('img');
      roundedImage.src = roundedCanvas.toDataURL();
      roundedImage.name = 'trimed';
      roundedImage.id = 'trimed'; //result.innerHTML = '';
      //result.appendChild(roundedImage);
    }; //onClick


    $(parentEl + '.triming_image').on('change', function (event) {
      var trimingImage = event.target.files; //buttonを有効

      button.disabled = false; // imageタグは1つしかファイルを送信できない仕組みと複数送信する仕組みの二通りありますので、サーバー側でチェックを忘れないようにしてください。

      if (trimingImage.length > 1) {
        console.log(trimingImage.length + 'つのファイルが選択されました。');
        return false;
      } // 改め代入します。


      trimingImage = trimingImage[0]; //２MB以上の画像をはじく

      if (trimingImage.size > 6000000) {
        //alert('サイズは6MB以内の写真を選んでください');
        swal("ご注意ください", "サイズは6MB以内の写真を選んでください");
        return false;
      } // 画像のチェックを行いますが、あくまでjsでのチェックなのでサーバーサイドでもう一度チェックを行ってください。


      if (!trimingImage.type.match('image/jp.*') // jpg jpeg でない
      && !trimingImage.type.match('image/png') // png でない
      && !trimingImage.type.match('image/gif') // gif でない
      && !trimingImage.type.match('image/bmp') // bmp でない
      ) {
          //alert('No Suport ' + trimingImage.type + ' type image');
          swal("ご注意ください", trimingImage.type + "のファイルは対応していません。");
          $(this).val('');
          return false;
        }

      var fileReader = new FileReader();

      fileReader.onload = function (e) {
        var int32View = new Uint8Array(e.target.result); // see https://en.wikipedia.org/wiki/List_of_file_signatures
        // ファイルのヘッダを参照し、マイムタイプを疑似的に取得します。フレームワークによってはもっと簡単に正確に読めるものもあります。
        // 下記は厳しい設定です。正規の手順を踏んでもアップロードできないカメラなどがあります。
        // （私の環境ではアクションカメラの写真などは下記に引っ掛かりました。）

        if (int32View.length > 4 && int32View[0] == 0xFF && int32View[1] == 0xD8 && int32View[2] == 0xFF && int32View[3] == 0xE0 || int32View.length > 4 && int32View[0] == 0xFF && int32View[1] == 0xD8 && int32View[2] == 0xFF && int32View[3] == 0xDB || int32View.length > 4 && int32View[0] == 0xFF && int32View[1] == 0xD8 && int32View[2] == 0xFF && int32View[3] == 0xD1 || int32View.length > 4 && int32View[0] == 0x89 && int32View[1] == 0x50 && int32View[2] == 0x4E && int32View[3] == 0x47 || int32View.length > 4 && int32View[0] == 0x47 && int32View[1] == 0x49 && int32View[2] == 0x46 && int32View[3] == 0x38 || (int32View.length = 2 && int32View[0] == 0x42 && int32View[1] == 0x4D && int32View[2] == 0x46 && int32View[3] == 0x38)) {
          // success
          $(parentEl + '.trimed_image').attr('src', URL.createObjectURL(trimingImage));
          return true;
        } else {
          // failed
          //alert('No Suport ' + trimingImage.type + ' type image');
          swal("ご注意ください", trimingImage.type + "のファイルは対応していません。"); // exeファイルのアップロードを考えると下記よりもいいプラクティスがある可能性があります。

          $(parentEl + '.trimed_image').val('');
          return false;
        }
      };

      fileReader.readAsArrayBuffer(trimingImage);

      fileReader.onloadend = function (e) {
        cropper.replace(URL.createObjectURL(trimingImage));
      }; //fileReader.onloadend

    }); //onChange
  } //function


  if ($('body').hasClass('page-cropper') || $('body').hasClass('page-order-cropper') || $('body').hasClass('page-confirm')) {
    var forder = '/wp-content/uploads/send/';
    $('.triming-stage').each(function (i, el) {
      i++;
      var filename = $("input[name='filename0" + i + "']").val();
      var parentEl = '#triming-stage0' + i + ' ';

      if (filename !== undefined) {
        if (filename !== '') {
          $(parentEl + '.result').append('<img src="' + forder + filename + '" />');
        }
      }
    }); //checkboxで表示

    var checkEls = document.querySelectorAll('.cropper-visible');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = checkEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var checkEl = _step.value;
        checkEl.addEventListener('change', function () {
          cropperVisible(this.value, this.checked);
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  function cropperVisible(id, ischecked) {
    if (ischecked == true) {
      document.getElementById(id).style.display = 'block';
    } else {
      document.getElementById(id).style.display = 'none';
    }
  } //画像修正


  if ($('body').hasClass('page-uploadform') || $('body').hasClass('page-error page-uploadform-child')) {
    var revisionBtn = document.getElementById('revisionBtn');

    revisionBtn.onclick = function () {
      var formRev = document.getElementById('imageRevision');
      var orderNum = $('input[name=order-number]').val();
      var buyerEmail = $('input[name=email]').val();
      var modelName = $('input[name=model-name]').val();
      var contents = $('textarea[name=contents]').val();
      var data = {
        'orderNum': orderNum,
        'buyerEmail': buyerEmail,
        'modelName': modelName,
        'contents': contents
      };

      for (var paramName in data) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', paramName);
        input.setAttribute('value', data[paramName]);
        formRev.appendChild(input);
      }

      formRev.submit();
    };
  }
})(jQuery);